import { createBrowserHistory } from 'history';

export default createBrowserHistory();



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/history.js